import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import axios from "axios";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function News() {
  const [articles, setArticles] = useState([]);
  const { t } = useLang();

  useEffect(() => {
    axios.get(`${API}/news`).then((r) => setArticles(r.data)).catch(() => {});
  }, []);

  return (
    <section id="actualites" data-testid="news-section" className="py-28 lg:py-40 bg-[#0A0A0C]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-20"
        >
          <p className="text-[#C5A059] text-xs uppercase tracking-[0.4em] mb-6">{t("news.eyebrow")}</p>
          <h2 className="font-display text-4xl md:text-5xl uppercase font-bold tracking-tight leading-tight">
            {t("news.title")}
          </h2>
        </motion.div>

        <div className="border-t border-[#27272A]">
          {articles.map((a, i) => (
            <motion.article
              key={a.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="group grid md:grid-cols-12 gap-6 items-center py-10 border-b border-[#27272A]"
              data-testid={`news-article-${i}`}
            >
              {a.image && (
                <div className="md:col-span-3 overflow-hidden border border-[#27272A]">
                  <img src={a.image} alt={a.titre} loading="lazy" className="w-full aspect-video object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-700" />
                </div>
              )}
              <div className={a.image ? "md:col-span-2" : "md:col-span-2"}>
                <span className="text-[#C5A059] text-[10px] uppercase tracking-[0.25em] border border-[#C5A059]/40 px-3 py-1.5">{a.tag}</span>
              </div>
              <div className={a.image ? "md:col-span-5" : "md:col-span-8"}>
                <h3 className="font-display text-2xl md:text-3xl uppercase font-medium group-hover:text-[#C5A059] transition-colors duration-300 leading-snug">
                  {a.titre}
                </h3>
                <p className="text-sm text-[#71717A] mt-3">{a.texte}</p>
              </div>
              <div className="md:col-span-2 flex md:justify-end items-center gap-4">
                <span className="text-xs text-[#71717A]">{a.date}</span>
                <ArrowUpRight size={20} className="text-[#71717A] group-hover:text-[#C5A059] group-hover:translate-x-1 group-hover:-translate-y-1 transition-[transform,color] duration-300" />
              </div>
            </motion.article>
          ))}
          {articles.length === 0 && (
            <p className="text-center text-[#71717A] text-sm py-12">{t("news.empty")}</p>
          )}
        </div>
      </div>
    </section>
  );
}
